import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Yup from 'yup';
import RichText from '../Prismic/RichText';
import InnerForm from './InnerForm';
import cx from 'classnames';

import './Form.scss';

const getInitialValues = props => {
  let values = {};
  const { items } = props;

  const removeSubmitField = field => field.inputType !== 'submit';
  const fieldValues = field => (values[field.inputName] = '');

  items.filter(removeSubmitField)
    .map(fieldValues);

  return values;
};

const getValidationSchema = props => {
  let schema = {};
  const { items } = props;

  const removeSubmitAndNonRequiredFields = field =>
    field.inputType !== 'submit' && field.required !== 'false';
  const errorMessages = field =>
    (schema[field.inputName] = Yup.string()
      .required(
        field.errorMessage || 'You must fill this out before submitting.',
      ));

  items.filter(removeSubmitAndNonRequiredFields)
    .map(errorMessages);

  return Yup.object()
    .shape(schema);
};

const Form = props => (
  <section className="form">
    <div className="container-guttered">
      <RichText fields={props.title} className="form-title" />
      <div
        className={cx('form-wrapper', {
          hidden: !props.formVisible,
        })}>
        <Formik
          onSubmit={props.handleSubmitForm}
          initialValues={getInitialValues(props)}
          validationSchema={getValidationSchema(props)}
          validateOnBlur={false}
          validateOnChange={false}>
          {formProps => (
            <InnerForm
              {...formProps}
              formId={props.formId}
              items={props.items}
            />
          )}
        </Formik>
      </div>
      {!props.formVisible && props.formSuccess && (
        <div className="form-successful">
          <p>{props.formSuccess}</p>
        </div>
      )}
    </div>
  </section>
);

Form.propTypes = {
  title: PropTypes.array,
  formVisible: PropTypes.bool.isRequired,
  formId: PropTypes.string.isRequired,
  formSuccess: PropTypes.string,
  handleSubmitForm: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  updateFormVisibility: PropTypes.func.isRequired,
};

export default Form;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Form/Form.js